import GatewayErrorInteractiveHandler from 'scripts/application/lib/gateway_error_interactive_handler';

// ApplyTaskTopicAssociations adds and/or removes org Topics on a task.
//
// Mirrors the conversation flow (UpdateConversationTopicIds) but targets the
// task-scoped REST endpoint added in supernova:
//   POST /api/v1/orgs/:orgId/tasks/:taskId/topic-associations
// The body is the shared conversationtopic.AssociationUpdate shape:
//   { associations: [{ topicId }], removeTopicIds: [id, ...] }
// The initiator is derived server-side from the JWT.
//
// The store is updated optimistically, like every sibling task mutation
// (UpdateTaskAssignee, MarkTaskClosed). The server's task-update broadcast
// still reconciles the item, but waiting for it would leave the multi-select
// diffing against stale topicIds — so removing a pill and then adding an
// unrelated topic would re-add the one just removed.
export default class ApplyTaskTopicAssociations {
  constructor(context) {
    this.context = context;
  }

  run({ taskId, topicChanges }) {
    const add = topicChanges.add || [];
    const remove = topicChanges.remove || [];
    if (!add.length && !remove.length) {
      return;
    }

    this._applyOptimisticUpdate(taskId, add, remove);

    this.context.gateways.taskTopicAssociations
      .add(
        { taskId },
        {
          associations: add.map(topicId => ({ topicId })),
          removeTopicIds: remove,
        }
      )
      .catch(err => new GatewayErrorInteractiveHandler(this.context).handleCommonErrors(err));

    this.context.analytics.track('Task Topics Updated', {
      taskId,
      topicsAdded: add,
      topicsRemoved: remove,
    });
  }

  _applyOptimisticUpdate(taskId, add, remove) {
    const store = this.context.stores.conversationHistory;
    // findBy rather than find: the pills can outlive the item in the store
    // (e.g. the feed switched customers mid-request) and find() throws.
    const taskItem = store.findBy({ id: taskId });
    if (!taskItem) {
      return;
    }

    taskItem.content.applyTopicChanges({ add, remove });
    store.setPending(taskItem);
  }
}
